<div class="container relative md:mt-24 mt-16">
  <div class="grid md:grid-cols-12 grid-cols-1 items-center gap-6 relative">
    <div class="md:col-span-5">
      <div class="relative">
        <img [src]="'assets/images/about.jpg'" class="mx-auto rounded-3xl shadow-[0_30px_40px_rgba(0,0,0,0.5)] dark:shadow-[0_30px_40px_rgba(0,0,0,0.9)] w-[90%]" alt="">

        <div class="absolute flex items-center bottom-3 md:-start-10 -start-5 p-4 rounded-lg shadow-[0_30px_40px_rgba(0,0,0,0.5)] dark:shadow-[0_30px_40px_rgba(0,0,0,0.9)] bg-white dark:bg-slate-900 w-56 m-3">
          <div class="flex items-center justify-center h-[65px] min-w-[65px] bg-red-500/5 text-red-500 text-center rounded-xl me-3">
            <i data-feather="users" class="size-6"></i>
          </div>
          <div class="flex-1">
            <span class="text-slate-400">Happy Guests</span>
            <p class="text-xl font-bold"><span class="counter-value" [countUp]="1200">1200</span>+</p>
          </div>
        </div>

        <div class="absolute flex items-center top-5 md:-end-10 -end-5 p-4 rounded-lg shadow-[0_30px_40px_rgba(0,0,0,0.5)] dark:shadow-[0_30px_40px_rgba(0,0,0,0.9)] bg-white dark:bg-slate-900 w-60 m-3">
          <div class="flex items-center justify-center h-[65px] min-w-[65px] bg-red-500/5 text-red-500 text-center rounded-xl me-3">
            <i data-feather="home" class="size-6"></i>
          </div>
          <div class="flex-1">
            <span class="text-slate-400">Unique Stays</span>
            <p class="text-xl font-bold"><span class="counter-value" [countUp]="20">20</span>+</p>
          </div>
        </div>
      </div>
    </div>

    <div class="md:col-span-7">
      <div class="lg:ms-8">
        <h3 class="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold">Welcome to HarmoNest <br> Your Smart Cozy Stay in Germany</h3>

        <p class="text-slate-400 max-w-xl mb-6">
          Discover handpicked apartments in top German cities like Berlin, Stuttgart, and Düsseldorf. At HarmoNest, we offer short-term rentals that feel just like home—fully furnished, guest-ready, and optimized for comfort. Book your next stay with ease and peace of mind.
        </p>

        <a [routerLink]="['/aboutus']" class="py-2 px-5 inline-block tracking-wide align-middle duration-500 text-base text-center bg-red-500 text-white rounded-md">
          More <i class="mdi mdi-chevron-right align-middle ms-0.5"></i>
        </a>
      </div>
    </div>

    <div class="absolute bottom-0 start-1/3 -z-1">
      <img [src]="'assets/images/map-plane-big.png'" class="lg:w-[600px] w-96" alt="">
    </div>
  </div>
</div>
